import { render, staticRenderFns } from "./ItemSlider.vue?vue&type=template&id=7332ba42&scoped=true"
import script from "./ItemSlider.vue?vue&type=script&lang=js"
export * from "./ItemSlider.vue?vue&type=script&lang=js"
import style0 from "./ItemSlider.vue?vue&type=style&index=0&id=7332ba42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7332ba42",
  null
  
)

export default component.exports